// extracted by mini-css-extract-plugin
export default {"container":"dqrKRBiHLgZ0u3Mg98QJ","logoContainer":"fDTMVPLcE8TWNzKtxfWR","logo":"kWiO8fr0HTWHcTf9lFP3","text":"dmlovtJt9PTSm2TvrA7Z"};